const SUPPORTED_LANGUAGES = ['r', 'python', 'scala'];
const isSupportedLanguage = language => {
  return SUPPORTED_LANGUAGES.includes(language);
};
export default isSupportedLanguage;